import React, { useEffect, useRef } from 'react';

const COLORS = ['#3B4759', '#10B981', '#0EA5E9', '#F59E0B', '#F43F5E', '#14B8A6'];

export const ConfettiBurst = ({ fire, count = 90, origin, testId = 'confetti-burst' }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!fire || !ref.current || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const canvas = ref.current;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth; canvas.height = window.innerHeight;
    const ox = origin?.x ?? canvas.width / 2, oy = origin?.y ?? canvas.height * 0.35;
    const parts = Array.from({ length: count }, () => { const a = Math.random() * Math.PI * 2, s = 5 + Math.random() * 8; return { x: ox, y: oy, vx: Math.cos(a) * s, vy: Math.sin(a) * s - 6, r: 3 + Math.random() * 4, c: COLORS[Math.floor(Math.random() * COLORS.length)], rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3, life: 1 }; });
    let raf;
    const tick = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      let alive = false;
      parts.forEach((p) => {
        p.vy += 0.28; p.vx *= 0.985; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life -= 0.011;
        if (p.life <= 0) return; alive = true;
        ctx.save(); ctx.globalAlpha = Math.max(0, p.life); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillStyle = p.c; ctx.fillRect(-p.r, -p.r / 2, p.r * 2, p.r); ctx.restore();
      });
      if (alive) raf = requestAnimationFrame(tick); else ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [fire, count, origin]);
  return <canvas ref={ref} data-testid={testId} data-fired={fire ? 'true' : 'false'} className="pointer-events-none fixed inset-0 z-50" aria-hidden="true" />;
};
